import React from 'react';

import './Footer.scss';

const Footer = () => (
    <footer className="footer bg-dark">
        <div className="container">
            <p className="footer-content">
                Desarrollado por <a href="https://github.com/developaul" target="_blank" rel="noopener noreferrer">@developaul</a>
            </p>
        </div>
    </footer>
);

export default Footer;